// extracted by mini-css-extract-plugin
export default {"section":"FeatureList_section__xejGR","heading":"FeatureList_heading__wgOjj","list":"FeatureList_list__MkjFu"};